import apiClient from './api_client';

export type SubscriptionStatus = {
    status: string;
    quantity: number;
    next_billing_date?: string;
    cancel_at?: string;
    trial_end?: string;
};

export type InvoiceData = {
    id: string;
    status: string;
    amount_due: number;
    currency: string;
    is_upcoming: boolean;
    created?: number;
    hosted_invoice_url?: string;
};

export type InvoiceListResponse = {
    invoices: InvoiceData[];
    has_more: boolean;
};

export async function getSubscriptionStatus(
    tenantId: string
): Promise<SubscriptionStatus> {
    const url = `/billing/subscription?tenant_id=${encodeURIComponent(tenantId)}`;
    const response = await apiClient.get(url);
    return await response.json();
}

export async function getInvoices(
    tenantId: string,
    limit: number = 10,
    startingAfter?: string
): Promise<InvoiceListResponse> {
    const params = new URLSearchParams({
        tenant_id: tenantId,
        limit: String(limit)
    });
    if (startingAfter) {
        params.set('starting_after', startingAfter);
    }
    const response = await apiClient.get(`/billing/invoices?${params}`);
    return await response.json();
}

export async function createPortalSession(
    tenantId: string,
    returnPath?: string
): Promise<{ url: string }> {
    return await apiClient.post('/billing/create-portal-session', {
        tenant_id: tenantId,
        return_path: returnPath
    });
}

export async function createUpgradeProSession(
    tenantId: string,
    returnPath?: string
): Promise<{ url: string }> {
    return await apiClient.post('/billing/upgrade-pro', {
        tenant_id: tenantId,
        return_path: returnPath
    });
}

export async function startFreeTrial(
    tenantId: string
): Promise<{ status: string }> {
    return await apiClient.post('/billing/start-free-trial', {
        tenant_id: tenantId
    });
}
